import { createApp } from "vue";
import AppWrapper from "./AppWrapper.vue";
import * as Sentry from "@sentry/browser";
import seedrandom from "seedrandom";

import "./css-reset.css";

const App = createApp(AppWrapper);

// Create a random seed to determin if we should collect errors for Sentry
const rng = new seedrandom();
if (Math.abs(rng.int32()) < 1000000) {
  Sentry.init({
    dsn:
      "https://6e143b5bdc2944ffa4347e0184bf5476@o106904.ingest.sentry.io/5424618",
    environment: process.env.NODE_ENV,
    whitelistUrls: [/https?:\/\/(.)*\.fresh8.co/]
  });
}

App.config.errorHandler = function(err) {
  Sentry.captureException(err);
  console.error(err);
};

App.mount("#app");
